import { render, staticRenderFns } from "./product-variants-table-badge.vue?vue&type=template&id=e4e5d34e&scoped=true"
import script from "./product-variants-table-badge.vue?vue&type=script&lang=js"
export * from "./product-variants-table-badge.vue?vue&type=script&lang=js"
import style0 from "./product-variants-table-badge.vue?vue&type=style&index=0&id=e4e5d34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e5d34e",
  null
  
)

export default component.exports